import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import PhoneHeader from "../../Components/Common/PhoneHeader";
import { ReactComponent as Alert } from "../../assets/icons/alert.svg";
const Rotate = () => {
  const history = useHistory();
  useEffect(() => {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    window.orientation == 0 && isMobile && history.replace("/Main");
    const listen = window.addEventListener(
      "orientationchange",
      function () {
        var isForbidden = window.orientation == 0 && isMobile;
        if (isForbidden) {
          history.replace("/Main");
        }
      },
      false
    );
    return () => {
      window.removeEventListener("orientationchange", listen);
    };
  }, []);
  useEffect(() => {
    window.scrollTo({
      top: document.getElementById("WarnSpan").offsetBottom,
      behavior: "smooth",
    });
  }, []);
  return (
    <div className="Container">
      <PhoneHeader text={" "} />
      <Alert
        id="WarnSpan"
        width={window.innerWidth * 0.25}
        height={window.innerHeight * 0.25}
        style={{ marginTop: window.innerHeight * 0.1 }}
        fill={"#ec4d11"}
      />
      <span style={{ marginTop: window.innerHeight * 0.025 }}>
        برای استفاده از برنامه کنتور، لطفا گوشی تلفن همراه خود را در حالت عمودی
        قرار دهید
      </span>
    </div>
  );
};

export default Rotate;
